"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Restore an undo snapshot into editor
 * @param core The editor core object
 * @param step Steps to move, can be 0, positive or negative
 */
exports.restoreUndoSnapshot = function (core, step) {
    if (core.undo.hasNewContent && step < 0) {
        core.api.addUndoSnapshot(core, null /*callback*/, null /*changeSource*/, false /*canUndoByBackspace*/);
    }
    var snapshot = core.undo.snapshotsService.move(step);
    if (snapshot != null) {
        try {
            core.undo.isRestoring = true;
            core.api.setContent(core, snapshot, true /*triggerContentChangedEvent*/);
        }
        finally {
            core.undo.isRestoring = false;
        }
    }
};
//# sourceMappingURL=restoreUndoSnapshot.js.map